<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <CommFilterBar :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction" />
      <div class="comm-panel">
        <div class="tbl-scroll-host">
          <el-table
            class="comm-table"
            empty-text="暂无数据"
            :data="records"
            row-key="recordId"
            size="small"
            height="100%"
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column type="selection" width="44" align="center" />
            <el-table-column prop="recordId" label="记录ID" min-width="120" show-overflow-tooltip />
            <el-table-column label="班级·学生" min-width="140">
              <template slot-scope="scope">
                <div class="comm-cell-stack">
                  <div>{{ scope.row.departmentName || '—' }}</div>
                  <div class="comm-cell-sub">
                    {{ scope.row.studentName || '—' }}
                    <span v-if="scope.row.studentNo">（{{ scope.row.studentNo }}）</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="主叫 / 被叫" min-width="160">
              <template slot-scope="scope">
                <div class="comm-cell-stack">
                  <div><span class="comm-cell-muted">主</span>{{ scope.row.caller || '—' }}</div>
                  <div>
                    <span class="comm-cell-muted">被</span>{{ scope.row.called || '—' }}
                    <span v-if="scope.row.calledName" class="comm-cell-sub"> {{ scope.row.calledName }}</span>
                  </div>
                  <div v-if="scope.row.deviceSn" class="comm-cell-sub"><span class="comm-cell-muted">设备</span>{{ scope.row.deviceSn }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="类型·时间" min-width="140">
              <template slot-scope="scope">
                <div class="comm-cell-stack">
                  <div>
                    <el-tag :type="callTypeTagType(scope.row.callType)" size="mini">{{ scope.row.callType }}</el-tag>
                    <el-tag v-if="scope.row.isTbVideophone" type="warning" size="mini" style="margin-left: 4px">天波</el-tag>
                  </div>
                  <div class="comm-cell-sub">{{ formatCreateTime(scope.row.createTime) }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="时长·扣费" width="110">
              <template slot-scope="scope">
                <div class="comm-cell-stack">
                  <div>{{ scope.row.duration }}</div>
                  <div class="comm-cell-sub">{{ scope.row.fee }}</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import './styles/comm-page.css'
import util from '../../../util/date'
import CommFilterBar from './components/CommFilterBar.vue'
import DepartmentPane from '../../components/DepartmentPane'
import { getCommCallRecordListPage, exportCommCallRecords } from '../../api/modules/communication'

const defaultButtons = [
  { name: '查询', Func: 'handleQuery' },
  { name: '导出', Func: 'handleExport', plain: true }
]

/** 格式化为 yyyy-MM-dd。创建于 2026-08-08 */
function formatDay(d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/** 最近七天（含今天）：开始=今天-6，结束=今天。创建于 2026-08-08 */
function recentSevenDaysRange() {
  const end = new Date()
  end.setHours(0, 0, 0, 0)
  const start = new Date(end)
  start.setDate(start.getDate() - 6)
  return { date: formatDay(start), endDate: formatDay(end) }
}

export default {
  components: { CommFilterBar, DepartmentPane },
  data() {
    const range = recentSevenDaysRange()
    return {
      filters: {
        date: range.date,
        endDate: range.endDate,
        studentName: '',
        studentNo: '',
        callType: ''
      },
      departmentId: '',
      searchList: [
        { label: '开始', key: 'date', type: 'date', initValue: range.date, width: '150px' },
        { label: '结束', key: 'endDate', type: 'date', initValue: range.endDate, width: '150px' },
        { label: '姓名', key: 'studentName', initValue: '', width: '120px', placeholder: '姓名' },
        { label: '学号', key: 'studentNo', initValue: '', width: '120px', placeholder: '学号' },
        {
          label: '类别',
          key: 'callType',
          type: 'select',
          initValue: '',
          width: '110px',
          options: [
            { label: '全部', value: '' },
            { label: '呼入', value: 1 },
            { label: '呼出', value: 2 }
          ]
        }
      ],
      buttonList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      records: []
    }
  },
  methods: {
    normalizeCallRecordRow(raw) {
      if (!raw || typeof raw !== 'object') return {}
      const id = raw.id != null ? raw.id : raw.Id
      const callTypeRaw = raw.callType != null ? raw.callType : raw.CallType
      const startTime = raw.startTime != null ? raw.startTime : raw.StartTime
      const durationSeconds = Number(raw.durationSeconds != null ? raw.durationSeconds : raw.DurationSeconds) || 0
      const requestedDeductMinutes = Number(raw.requestedDeductMinutes != null ? raw.requestedDeductMinutes : raw.RequestedDeductMinutes) || 0
      const deductMinutes = Number(raw.deductMinutes != null ? raw.deductMinutes : raw.DeductMinutes) || 0
      const recordSource = raw.recordSource != null ? raw.recordSource : raw.RecordSource
      const isTbVideophone = recordSource === 'TbVideophone'
      let fee = '天波免费'
      if (!isTbVideophone) {
        if (requestedDeductMinutes > 0 && requestedDeductMinutes !== deductMinutes) {
          fee = '应扣 ' + requestedDeductMinutes + ' / 实扣 ' + deductMinutes + ' 分钟'
        } else {
          fee = '扣减 ' + deductMinutes + ' 分钟'
        }
      }
      return {
        ...raw,
        id,
        recordId: id,
        recordSource,
        isTbVideophone,
        departmentName: raw.departmentName != null ? raw.departmentName : raw.DepartmentName,
        studentName: raw.studentName != null ? raw.studentName : raw.StudentName,
        studentNo: raw.studentNo != null ? raw.studentNo : raw.StudentNo,
        caller: raw.caller != null ? raw.caller : raw.Caller,
        deviceSn: raw.deviceSn != null ? raw.deviceSn : raw.DeviceSn,
        called: raw.callee != null ? raw.callee : raw.Callee,
        calledName: raw.calledName != null ? raw.calledName : raw.CalledName,
        createTime: startTime,
        duration: `${Math.floor(durationSeconds / 60)}分${durationSeconds % 60}秒`,
        fee,
        callType: callTypeRaw === 1 ? '呼入' : (callTypeRaw === 2 ? '呼出' : callTypeRaw)
      }
    },
    formatCreateTime(val) {
      return !val || val === '' ? '' : util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss')
    },
    callTypeTagType(type) {
      if (!type) return ''
      const t = String(type).toLowerCase()
      if (t.indexOf('电话') !== -1 || t.indexOf('phone') !== -1) return 'success'
      if (t.indexOf('微信') !== -1 || t.indexOf('weixin') !== -1 || t.indexOf('wechat') !== -1) return 'info'
      if (t.indexOf('视') !== -1 || t.indexOf('视频') !== -1) return 'warning'
      if (t === '呼入') return 'success'
      if (t === '呼出') return ''
      return ''
    },
    handleCurrentChange(p) {
      this.page = p
      this.handleQuery()
    },
    treeNodeClick(data) {
      this.departmentId = data && data.value ? data.value : ''
      this.page = 1
      this.handleQuery()
    },
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : {}
      if (typeof this[item.Func] === 'function') this[item.Func]()
    },
    buildQueryParams(withPage) {
      const params = {
        studentName: this.filters.studentName || '',
        studentNo: this.filters.studentNo || '',
        callType: this.filters.callType || '',
        departmentId: this.departmentId || '',
        date: this.filters.date || '',
        endDate: this.filters.endDate || ''
      }
      if (withPage) {
        params.page = this.page
        params.pageSize = this.pageSize
      }
      return params
    },
    async handleQuery() {
      this.loading = true
      try {
        const res = await getCommCallRecordListPage(this.buildQueryParams(true))
        if (res.data.success) {
          const pageData = res.data.response || {}
          const list = pageData.data || pageData.Data || []
          this.records = list.map((item) => this.normalizeCallRecordRow(item))
          this.total = pageData.dataCount != null ? pageData.dataCount : (pageData.DataCount || 0)
        } else {
          this.$message.error(res.data.msg || '查询失败')
        }
      } finally {
        this.loading = false
      }
    },
    async handleExport() {
      const res = await exportCommCallRecords(this.buildQueryParams(false))
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `话机通话记录_${new Date().getTime()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.buttonList = defaultButtons
  }
}
</script>
